import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import mixinDisabled from '../../mixins/disabled';
import { PhxDropdownComponent } from '../dropdown/phx-dropdown.component';
import { PhxButtonSize, PhxButtonType, PhxButtonRole } from '../button/phx-button.component';
import { POSITION_TYPE } from '../dropdown/overlay-position';
import { PhxBackground } from '../../types';
import { ChevronDown } from './../icon/icon-map';

const baseButtonMixin = mixinDisabled(
  class {
    constructor() {}
  }
);

@Component({
  selector: 'phx-menu-button',
  styleUrls: ['./phx-menu-button.scss'],
  templateUrl: './phx-menu-button.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: [
    'disabled'
  ],
})
export class PhxMenuButtonComponent extends baseButtonMixin {
  @Input() public phxSize: PhxButtonSize = 'medium';
  @Input() public phxBackground: PhxBackground = 'standard';
  @Input() public phxButtonType: PhxButtonType = 'default';
  @Input() public phxButtonRole: PhxButtonRole = 'primary';
  @Input() public phxLoading: boolean = false;
  @Input() public phxDisableInteractions: boolean = false;
  @Input() public phxPrefixIcon: string;
  @Input() public phxSuffixIcon: string = ChevronDown;
  @Input() public phxDropdownTemplate: PhxDropdownComponent;
  @Input() public phxDropdownPosition: POSITION_TYPE = 'bottomLeft';
  @Input() public phxHasShadow: boolean = false;
  @Input() public phxFullWidth: boolean = false;

}

